import { render, staticRenderFns } from "./NavigationDesktop.vue?vue&type=template&id=7ecd0d8b&scoped=true"
import script from "./NavigationDesktop.vue?vue&type=script&lang=js"
export * from "./NavigationDesktop.vue?vue&type=script&lang=js"
import style0 from "./NavigationDesktop.vue?vue&type=style&index=0&id=7ecd0d8b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecd0d8b",
  null
  
)

export default component.exports